module.exports = __webpack_public_path__ + "img/facebook.1d236e42.svg";